import { inject, Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import { InvitationResponseModel } from "@itb-monorepo/models";
import { InvitationCreateModel } from "@itb-monorepo/models";


@Injectable()
export class InvitationsService {
  baseUrl = '/member/';
  private _HttpMainService = inject(HttpMainService);

  createInvitation(model: InvitationCreateModel, cfTrunsTile: string): Observable<InvitationResponseModel> {
    const header = { 'cf-turnstile-response': cfTrunsTile };
    return this._HttpMainService.post(this.baseUrl + "v1/invitations", model, header);
  }
}
